/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Release_Dialog_Full_ChangelogInputs */



/**
* | output |
* | --- |
* | "Full changelog" |
*
* @param {Release_Dialog_Full_ChangelogInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const release_dialog_full_changelog = /** @type {((inputs?: Release_Dialog_Full_ChangelogInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Release_Dialog_Full_ChangelogInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Alle Änderungen")
	return /** @type {LocalizedString} */ ("Full changelog")
});